export default {
  PURCHASES_ORDERS_LIST: "Liste des commandes",
  ADD_PURCHASES_ORDER: "Ajouter une commande",
  ADD_PURCHASES_ORDER_ITEM: "Ajouter une ligne",
  PURCHASES_ORDER_ADDED: "Commande ajoutée",
  OWNER: "Propriétaire",
  EDIT_PURCHASES_ORDER: "Modifier une commande",
  PURCHASES_ORDER_UPDATED: "Commande mise à jour",
  BILLING_ADDRESS: "Adresse de facturation",
  EXPIRATION_TIME: "Date d'expiration",
  ITEM_TYPE: "Type",
  SELECT_PRODUCTS: "Choisir un produit",
  SELECT_SUBSCRIPTIONS: "Choisir une inscription",
  SELECT_PACKAGES: "Choisir un forfait",
  DELETE_PURCHASES_ORDER_ITEM: "Supprimer la ligne",
  UPDATE_PURCHASES_ORDER_ITEM: "Modifier la ligne",
  PURCHASES_ORDER_ITEM_DELETED: "Ligne supprimée",
  PURCHASES_ORDER_ITEM_ADDED: "Ligne ajoutée",
  PURCHASES_ORDER_ITEM_EDITED: "Ligne modifiée",
  SEND: "Envoyer",
  CANCEL: "Annuler",
  REFUND: "Rembourser",
  ADD_PAYMENT: "Ajouter un paiement",
  PURCHASES_ORDER_SENT: "Commande envoyée",
  SELECT_USERS: "Choisir l'utilisateur",
  SELECT_CUSTOMERS: "Choisir le client",
  SELECT_ORGANIZATIONS: "Choisir l'organization",
  SELECT_SUPPLIERS: "Choisir le fournisseur",
  DELETE_THIS_PURCHASES_ORDER: "Supprimer cette commande?",
  PURCHASES_ORDER_DELETED: "Commande supprimée",
  CANCEL_PURCHASES_ORDER_QUESTION: "Annuler la commande?",
  PURCHASES_ORDER_CANCELED: "Commande annulée",
  RECIPIENT: "Destinataire",
  ISSUER: "Émetteur",
  VALIDATE: "Valider",
  PURCHASES_ORDER_VALIDATED: "Commande validée",
  GENERATE_INVOICE: "Créer la facture",
  INVOICE_GENERATED: "Facture crée",
  VIEW_INVOICE: "Voir la facture",
  ADD_DELIVERY: "Ajouter une livraison",
  DELIVERIES_STATE: "État de livraison",
  DELIVERIES_STATE_ITEM: "Produit",
  DELIVERIES_STATE_ORDERED_QUANTITY: "Quantité commandée",
  DELIVERIES_STATE_DELIVERED_QUANTITY: "Quantité Livrée",
  DELIVERIES_STATE_REMAINING_QUANTITY: "Quantité Restant",
  DELIVERIES_STATE_REMAINING_QUANTITY: "Quantité Restant",
  NOT_INVOICED: "A facturer",
  NOT_DELIVERED: "A Livrer",
  DELIVERED: "Livrée",
  VIEW_PURCHASES_ORDER: "Commande achat",
  PURCHASES_INVOICES: "Factures achat",
  ADD_INVOICE: "Ajouter une facture",
  INVOICING_TYPE: "Type de facturation",
  INVOICING_TYPE_COMPLETE: "Complète",
  INVOICING_TYPE_AMOUNT: "Montant",
  INVOICING_TYPE_PRODUCT: "Produit",
  INVOICING_STATUS_PENDING: "Non Facturée",
  INVOICING_STATUS_PARTIALLY_INVOICED: "Partiellement facturée",
  INVOICING_STATUS_INVOICED: "Facturée",
  DELIVERY_STATUS_PENDING: "Non Livrée",
  DELIVERY_STATUS_PARTIALLY_DELIVERED: "Partiellement livrée",
  DELIVERY_STATUS_DELIVERED: "Livrée",
  INVOICING_STATUS: "Status facturation",
  ORDER_STATUS_DRAFT: "Brouillon",
  ORDER_STATUS_CANCELED: "Annulée",
  ORDER_STATUS_VALIDATED: "Validée",
  ORDER_STATUS_COMPLETED: "Complétée",
  DELIVERY_STATUS: "Status livraison",
  INVOICE_TYPE: "Type de facture",
  INVOICE_TYPE_DOWNPAYMENT: "Facture d'acompte",
  INVOICE_TYPE_STANDARD: "Facture standard",

  CREATED_AT: "Créée le",
};
